// // import React, { useState, useEffect } from "react";
// // import { getPartyBulkBillSummary } from "../../../api/endpoints/allReports.js";
// // import { authSelector } from "../../../store/selectors/index";
// // import { useSelector } from "react-redux";
// // import { message } from "antd";
// // import SideBar from "../../sidebar/sideBar.js";
// // import { getAllPartySearch } from "../../../api/endpoints/search.js";
// // import { Button, Dropdown, Select, Menu } from "antd";
// // import Header from "../../header/header.jsx";
// // import jsPDF from "jspdf";
// // import autoTable from "jspdf-autotable";
// // import { getSiteRefrence, updateRefrence } from "../../../api/endpoints/refrences";
// // import { getSingleParty } from "../../../api/endpoints/party.js";
// // const { Option } = Select;

// // const PartyBulkBillSummary = () => {
// //   const { user, access_token } = useSelector(authSelector);
// //   const [enteredOn, setEnteredOn] = useState("");
// //   const [siteName, setSiteName] = useState();
// //   const [siteAddress, setSiteAddress] = useState();

// //   const [state, setState] = useState({
// //     parties: [],
// //     partyId: "", //ac no.
// //     partyName: "", // supplier name
// //     enteredOn: "",
// //     reportType: "0",
// //     startingDate: "",
// //     customerNTN: "",
// //     customerSaleTaxNo: "",
// //     invNo: "",
// //     STR: "",
// //     NTN: "",
// //     siteAddress: "",
// //     siteName: "",
// //     phoneNo: "",
// //     Fax: "",
// //     email: "",

// //   });

// //   const onChangeText = (e, object) => {
// //     if (object) {
// //       const { name, value } = object;
// //       setState({
// //         ...state,
// //         [name]: value,
// //       });
// //     } else {
// //       const { name, value } = e.target;
// //       setState({
// //         ...state,
// //         [name]: value,
// //       });
// //     }
// //   };
// //   const [itemsQueue, setItemsQueue] = useState([]);

// //   function formatDate(inputDate) {
// //     const options = { year: "numeric", month: "long", day: "numeric" };
// //     const formattedDate = new Date(inputDate).toLocaleDateString(
// //       undefined,
// //       options
// //     );
// //     return formattedDate;
// //   }
// //   const formatDateDDMMYYYY = (dateStr) => {
// //     if (!dateStr) return "";
// //     const d = new Date(dateStr);
// //     const day = d.getDate();
// //     const month = d.getMonth() + 1; // months are 0-based
// //     const year = d.getFullYear();
// //     return `${day}/${month}/${year}`;
// //   };
// //   const getName = async (e) => {
// //     const result = await getSiteRefrence(access_token);
// //     if (result.success) {
// //       setSiteName(result.data.siteName);
// //       setSiteAddress(result.data.siteAddress);
// //     } else {
// //       message.error(result.message);
// //     }
// //   };

// //     const getAllData = async () => {
// //       const result = await getSiteRefrence(access_token);
// //       const _parties = await getAllPartySearch(access_token);
// //       setState({
// //         ...state,
// //         parties: _parties,
// //         STR: result.data.saleTaxNo,
// //         NTN: result.data.NTNNO,
// //         phoneNo: result.data.phoneNo,
// //         Fax: result.data.Fax,
// //         email: result.data.email,
// //         siteAddress: result.data.siteAddress,
// //         siteName: result.data.siteName
  
// //       });
// //     };

// //   useEffect(() => {
// //     getAllData();
// //     getName();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   const [loading, setLoading] = useState(false);
// //   const editHandler = async (e) => {
// //     if (!state.enteredOn) return message.error("Please type Ending date !");
// //     if (!state.startingDate)
// //       return message.error("Please type Starting date !");
// //     if (!state.partyId) return message.error("Please type Party Id !");
// //     let data = {
// //       startingDate: state.startingDate,
// //       enteredOn: state.enteredOn,
// //       partyId: state.partyId,
// //     };
// //     try {
// //       setLoading(true); // disable button
// //       const results = await getPartyBulkBillSummary(data, access_token);
// //       if (results.data.length === 0) {
// //         message.error("No Record Found in these date");
// //       }
// //       if (results.success) {
// //         const payload = results.data.reduce((acc, curr) => {
// //           return [
// //             ...acc,
// //             {
// //               enteredOn: curr.enteredOn,
// //               partyId: Number(curr.partyId),
// //               regNumber: curr.regNumber,
// //               partyName: curr.partyName,
// //               itemCode: curr.itemCode,
// //               itemName: curr.itemName,
// //               saleRate: Number(curr.saleRate),
// //               quantity: Number(curr.quantity),
// //               // saleQuantity: Number(curr.saleQuantity),
// //               amount: Number(curr.amount),
// //               siteId: curr.siteId,
// //             },
// //           ];
// //         }, []);
// //         setItemsQueue(payload);
// //         generatePDF(payload);
// //       } else {
// //         message.error(results.message);
// //       }
// //     } catch (err) {
// //       message.error("Something went wrong!");
// //       console.error(err);
// //     } finally {
// //       setLoading(false); // re-enable button
// //     }
// //   };

// //   const clearState = () => {
// //     setItemsQueue([]);
// //   };


  


// // const generatePDF = (data) => {
// //   if (!data || data.length === 0) {
// //     message.error("No data to generate PDF");
// //     return;
// //   }

// //   const doc = new jsPDF("p", "mm", "a4");

// //   /* ================= HEADER (CENTER) ================= */
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(14);
// //   doc.text(state.siteName || "", 105, 15, { align: "center" });

// //   doc.setFont("helvetica", "normal");
// //   doc.setFontSize(10);
// //   doc.text(state.siteAddress || "", 105, 21, { align: "center" });

// //   /* ================= DATE (CENTER) ================= */
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(10);
// //   doc.text(
// //     `${formatDateLong(state.startingDate)} to ${formatDateLong(state.enteredOn)}`,
// //     105,
// //     28,
// //     { align: "center" }
// //   );

// //   /* ================= PARTY INFO (LEFT) ================= */
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(10);
// //   doc.text("Cutomer:", 14, 36);

// //   doc.setFont("helvetica", "normal");
// //   doc.text(state.partyName || "", 31, 36);

// //   /* ================= TABLE ================= */
// // const tableRows = data.map((r, index) => [
// //   index + 1,
// //   formatDateLong(r.enteredOn),          
// //   r.itemName,                           
// //   r.regNumber || "",                    
// //   r.quantity.toLocaleString(undefined, { minimumFractionDigits: 2 }),
// //   r.saleRate.toLocaleString(undefined, { minimumFractionDigits: 2 }),
// //   r.amount.toLocaleString(undefined, { minimumFractionDigits: 2 }),
// // ]);


// // const totalQty = data.reduce((a, b) => a + Number(b.quantity || 0), 0);
// // const totalAmount = data.reduce((a, b) => a + Number(b.amount || 0), 0);

// // tableRows.push([
// //   "",
// //   "",
// //   "TOTAL",
// //   "",
// //   totalQty.toLocaleString(undefined, { minimumFractionDigits: 2 }),
// //   "",
// //   `Rs. ${totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
// // ]);


// // autoTable(doc, {
// //   startY: 42,
// //   head: [["#", "Date", "Item", "Vehicle", "Qty", "Rate", "Amount"]],
// //   body: tableRows,
// //   theme: "grid",
// //   styles: {
// //     fontSize: 9,
// //     cellPadding: 2,
// //     textColor: [0, 0, 0],
// //     lineColor: [0, 0, 0],
// //     lineWidth: 0.3,
// //   },
// //   headStyles: {
// //     fontStyle: "bold",
// //     textColor: [0, 0, 0],
// //     fillColor: [255, 255, 255],
// //   },
// //   columnStyles: {
// //     0: { halign: "center", cellWidth: 8 },   // #
// //     1: { halign: "center", cellWidth: 30 },  // Date
// //     2: { halign: "left",   cellWidth: 40 },  // Item
// //     3: { halign: "center", cellWidth: 25 },  // Vehicle
// //     4: { halign: "right",  cellWidth: 20 },  // Qty
// //     5: { halign: "right",  cellWidth: 20 },  // Rate
// //     6: { halign: "right",  cellWidth: 30 },  // Amount
// //   },
// //   didParseCell: (d) => {
// //     if (d.row.raw?.[2] === "TOTAL") {
// //       d.cell.styles.fontStyle = "bold";
// //     }
// //   },
// // });


// // /* ================= AMOUNT IN WORDS ================= */
// // let y = doc.lastAutoTable.finalY + 10;

// // doc.setFont("helvetica", "bold");
// // doc.setFontSize(11);
// // doc.text("Amount in Words:", 14, y);

// // doc.setFont("helvetica", "normal");

// // // full text
// // const amountInWords = `Rupees ${numberToWords(totalAmount)} Only`;

// // // max width for wrapping (A4 safe width)
// // const maxWidth = 180;

// // // auto split into multiple lines
// // const wrappedText = doc.splitTextToSize(amountInWords, maxWidth);

// // // render multiline text
// // doc.text(wrappedText, 14, y + 6);


  
// //   /* ================= OPEN PDF ================= */
// //   const pdfBlob = doc.output("blob");
// //   window.open(URL.createObjectURL(pdfBlob));
// // };


// // /* ================= HELPERS ================= */

// // // Format date like "10 January 2026"
// // function formatDateLong(date) {
// //   if (!date) return "";
// //   const d = new Date(date);
// //   const options = { day: "numeric", month: "long", year: "numeric" };
// //   return d.toLocaleDateString("en-US", options);
// // }

// // // Convert number to words
// // const numberToWords = (amount) => {
// //   const th = ["", "Thousand", "Million", "Billion", "Trillion"];
// //   const dg = ["Zero","One","Two","Three","Four","Five","Six","Seven","Eight","Nine"];
// //   const tn = ["Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
// //   const tw = ["Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
// //   amount = amount.toString().replace(/[\, ]/g,'');
// //   if(isNaN(amount)) return "Not a number";
// //   let x=amount.indexOf(".");
// //   let n=x===-1?amount.length:x;
// //   let str=""; let sk=0;
// //   for(let i=0;i<n;i++){
// //     if((n-i)%3===2){
// //       if(amount[i]==="1"){
// //         str+=tn[Number(amount[i+1])] + " "; i++; sk=1;
// //       } else if(amount[i]!=="0"){
// //         str+=tw[Number(amount[i])-2] + " "; sk=1;
// //       }
// //     } else if(amount[i]!=="0"){
// //       str+=dg[Number(amount[i])] + " ";
// //       if((n-i)%3===0) str+="Hundred ";
// //       sk=1;
// //     }
// //     if((n-i)%3===1){
// //       if(sk) str+=th[(n-i-1)/3] + " "; sk=0;
// //     }
// //   }
// //   if(x!==-1){
// //     let y=amount.length; 
// //     str+="Point "; 
// //     for(let i=x+1;i<y;i++) str+=dg[Number(amount[i])] + " ";
// //   }
// //   return str.trim() + " Rupees Only";
// // };




// //   return (
// //     <>
// //       <div className="flex  bg-black main">
// //         <SideBar />
// //         <div className="h-full  flex flex-col content-center  w-full">
// //           <Header />
// //           <div className="flex justify-center mt-10">
// //             <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
// //               <div className="bg-blue-500 headingBox flex justify-center">
// //                 <h1 className=" text-white">Party Bulk Bill Summary</h1>
// //               </div>
// //                <div className="flex justify-center w-100">
// //                   <div>
// //                     <label className="text-white ml-2 mr-2" for="fname">
// //                       Account:
// //                     </label>
// //                     <Select
// //                       showSearch
// //                       style={{
// //                         cursor: "pointer !important",
// //                         background: "red !important",
// //                       }}
// //                       name="partyId"
// //                       placeholder="A/C No."
// //                       // className=" custom-select ant-select bg-black text-white inpTxt mt-5 p-1 h-9 w-64"
// //                       className="ant-select-item-option-active bg-black text-white  mt-5 h-9  w-64"
// //                       optionFilterProp="children"
// //                       value={state.partyId || "A/C No."}
// //                       onChange={(e) => {
// //                         console.log("e", e);

// //                         const _party = state.parties.find(
// //                           (el) => el.partyId === e
// //                         );
// //                         if (_party) {
// //                           setState({
// //                             ...state,
// //                             partyId: e,
// //                             partyName: _party.fullName,
// //                           });
// //                         } else {
// //                           setState({
// //                             ...state,
// //                             partyId: e,
// //                             partyName: "",
// //                           });
// //                         }
// //                       }}
// //                     >
// //                       <Option value={0}>None</Option>
// //                       {state.parties.map((el) => (
// //                         <Option
// //                           className="w-auto"
// //                           value={el.partyId}
// //                         >{`${el.partyId} - ${el.PartyName}`}</Option>
// //                       ))}
// //                     </Select>
// //                   </div>

                 
// //                 </div>
// //               <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
// //                 <div>
// //                   <label className="text-white" for="fname">
// //                     Starting Date:
// //                   </label>
// //                   <input
// //                     type="date"
// //                     name="startingDate"
// //                     value={state.startingDate}
// //                     onChange={onChangeText}
// //                     className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
// //                   />
// //                   <label className="text-white ml-2" for="fname">
// //                     Ending Date:
// //                   </label>
// //                   <input
// //                     type="date"
// //                     name="enteredOn"
// //                     value={state.enteredOn}
// //                     onChange={onChangeText}
// //                     className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
// //                   />
// //                 </div>
               

// //                 <div>
// //                   <button
// //                     className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
// //                       loading
// //                         ? "opacity-50 cursor-not-allowed"
// //                         : "hover:bg-blue-700"
// //                     }`}
// //                     onClick={editHandler}
// //                     disabled={loading}
// //                   >
// //                     {loading ? "Loading..." : "View"}
// //                   </button>
// //                   <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
// //                     clear
// //                   </button>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // export default PartyBulkBillSummary;

// import React, { useState, useEffect } from "react";
// import { getPartyBulkBillSummary, getPartyBulkBill } from "../../../api/endpoints/allReports.js";
// import { authSelector } from "../../../store/selectors/index";
// import { useSelector } from "react-redux";
// import { message } from "antd";
// import SideBar from "../../sidebar/sideBar.js";
// import { getAllPartySearch } from "../../../api/endpoints/search.js";
// import { Button, Dropdown, Select, Menu } from "antd";
// import Header from "../../header/header.jsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { getSiteRefrence, updateRefrence } from "../../../api/endpoints/refrences";
// import { getSingleParty } from "../../../api/endpoints/party.js";
// const { Option } = Select;

// const PartyBulkBillSummary = () => {
//   const { user, access_token } = useSelector(authSelector);
//   const [enteredOn, setEnteredOn] = useState("");
//   const [siteName, setSiteName] = useState();
//   const [siteAddress, setSiteAddress] = useState();

//   const [state, setState] = useState({
//     parties: [],
//     partyId: "", //ac no.
//     partyName: "", // supplier name
//     enteredOn: "",
//     reportType: "0",
//     startingDate: "",
//     customerNTN: "",
//     customerSaleTaxNo: "",
//     invNo: "",
//     STR: "",
//     NTN: "",
//     siteAddress: "",
//     siteName: "",
//     phoneNo: "",
//     Fax: "",
//     email: "",

//   });

//   const onChangeText = (e, object) => {
//     if (object) {
//       const { name, value } = object;
//       setState({
//         ...state,
//         [name]: value,
//       });
//     } else {
//       const { name, value } = e.target;
//       setState({
//         ...state,
//         [name]: value,
//       });
//     }
//   };
//   const [itemsQueue, setItemsQueue] = useState([]);

//   function formatDate(inputDate) {
//     const options = { year: "numeric", month: "long", day: "numeric" };
//     const formattedDate = new Date(inputDate).toLocaleDateString(
//       undefined,
//       options
//     );
//     return formattedDate;
//   }
//   const formatDateDDMMYYYY = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr);
//     const day = d.getDate();
//     const month = d.getMonth() + 1; // months are 0-based
//     const year = d.getFullYear();
//     return `${day}/${month}/${year}`;
//   };
//   const getName = async (e) => {
//     const result = await getSiteRefrence(access_token);
//     if (result.success) {
//       setSiteName(result.data.siteName);
//       setSiteAddress(result.data.siteAddress);
//     } else {
//       message.error(result.message);
//     }
//   };

//     const getAllData = async () => {
//       const result = await getSiteRefrence(access_token);
//       const _parties = await getAllPartySearch(access_token);
//       setState({
//         ...state,
//         parties: _parties,
//         STR: result.data.saleTaxNo,
//         NTN: result.data.NTNNO,
//         phoneNo: result.data.phoneNo,
//         // invNo: result.data.invoiceNo,
//         Fax: result.data.Fax,
//         email: result.data.email,
//         siteAddress: result.data.siteAddress,
//         siteName: result.data.siteName
  
//       });
//     };

//   useEffect(() => {
//     getAllData();
//     getName();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const [loading, setLoading] = useState(false);

//   // const editHandler = async (e) => {
//   //   if (!state.enteredOn) return message.error("Please type Ending date !");
//   //   if (!state.startingDate)
//   //     return message.error("Please type Starting date !");
//   //   if (!state.partyId) return message.error("Please type Party Id !");
//   //   let data = {
//   //     startingDate: state.startingDate,
//   //     enteredOn: state.enteredOn,
//   //     partyId: state.partyId,
//   //   };
//   //   try {
//   //     setLoading(true); // disable button
//   //     const results = await getPartyBulkBillSummary(data, access_token);
//   //     if (results.data.length === 0) {
//   //       message.error("No Record Found in these date");
//   //     }
//   //     if (results.success) {
//   //       const payload = results.data.reduce((acc, curr) => {
//   //         return [
//   //           ...acc,
//   //           {
//   //             enteredOn: curr.enteredOn,
//   //             partyId: Number(curr.partyId),
//   //             regNumber: curr.regNumber,
//   //             partyName: curr.partyName,
//   //             itemCode: curr.itemCode,
//   //             itemName: curr.itemName,
//   //             saleRate: Number(curr.saleRate),
//   //             quantity: Number(curr.quantity),
//   //             // saleQuantity: Number(curr.saleQuantity),
//   //             amount: Number(curr.amount),
//   //             siteId: curr.siteId,
//   //           },
//   //         ];
//   //       }, []);
//   //       setItemsQueue(payload);
//   //       generatePDF(payload);
//   //     } else {
//   //       message.error(results.message);
//   //     }
//   //   } catch (err) {
//   //     message.error("Something went wrong!");
//   //     console.error(err);
//   //   } finally {
//   //     setLoading(false); // re-enable button
//   //   }
//   // };

//   const clearState = () => {
//     setItemsQueue([]);
//   };

// const editHandler = async () => {
//   if (!state.enteredOn)
//     return message.error("Please type Ending date !");
    
//   if (!state.startingDate)
//     return message.error("Please type Starting date !");
    
//   if (!state.partyId)
//     return message.error("Please type Party Id !");

//   const data = {
//     startingDate: state.startingDate,
//     enteredOn: state.enteredOn,
//     partyId: state.partyId,
//   };

//   try {
//     setLoading(true);

//     // BOTH API CALLS
//     const [billResult, summaryResult] = await Promise.all([
//       getPartyBulkBill(data, access_token),
//       getPartyBulkBillSummary(data, access_token),
//     ]);

//     if (
//       !billResult.success &&
//       !summaryResult.success
//     ) {
//       return message.error("No Record Found");
//     }

//     // DETAIL DATA
//     const billPayload = billResult?.data?.map((curr) => ({
//       partyId: Number(curr.partyId),
//       partyName: curr.partyName,
//       itemCode: curr.itemCode,
//       itemName: curr.itemName,
//       saleRate: Number(curr.saleRate),
//       quantity: Number(curr.quantity),
//       amount: Number(curr.amount),
//       siteId: curr.siteId,
//     })) || [];

//     // SUMMARY DATA
//     const summaryPayload = summaryResult?.data?.map((curr) => ({
//       enteredOn: curr.enteredOn,
//       partyId: Number(curr.partyId),
//       regNumber: curr.regNumber,
//       partyName: curr.partyName,
//       itemCode: curr.itemCode,
//       itemName: curr.itemName,
//       saleRate: Number(curr.saleRate),
//       quantity: Number(curr.quantity),
//       amount: Number(curr.amount),
//       siteId: curr.siteId,
//     })) || [];

//     // SINGLE PDF
//     generatePDF(billPayload, summaryPayload);

//   } catch (err) {
//     console.log(err);
//     message.error("Something went wrong!");
//   } finally {
//     setLoading(false);
//   }
// };
  


// // const generatePDF = (data) => {
// //   if (!data || data.length === 0) {
// //     message.error("No data to generate PDF");
// //     return;
// //   }

// //   const doc = new jsPDF("p", "mm", "a4");

// //   /* ================= HEADER (CENTER) ================= */
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(14);
// //   doc.text(state.siteName || "", 105, 15, { align: "center" });

// //   doc.setFont("helvetica", "normal");
// //   doc.setFontSize(10);
// //   doc.text(state.siteAddress || "", 105, 21, { align: "center" });

// //   /* ================= DATE (CENTER) ================= */
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(10);
// //   doc.text(
// //     `${formatDateLong(state.startingDate)} to ${formatDateLong(state.enteredOn)}`,
// //     105,
// //     28,
// //     { align: "center" }
// //   );

// //   /* ================= PARTY INFO (LEFT) ================= */
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(10);
// //   doc.text("Cutomer:", 14, 36);

// //   doc.setFont("helvetica", "normal");
// //   doc.text(state.partyName || "", 31, 36);

// //   /* ================= TABLE ================= */
// // const tableRows = data.map((r, index) => [
// //   index + 1,
// //   formatDateLong(r.enteredOn),          
// //   r.itemName,                           
// //   r.regNumber || "",                    
// //   r.quantity.toLocaleString(undefined, { minimumFractionDigits: 2 }),
// //   r.saleRate.toLocaleString(undefined, { minimumFractionDigits: 2 }),
// //   r.amount.toLocaleString(undefined, { minimumFractionDigits: 2 }),
// // ]);


// // const totalQty = data.reduce((a, b) => a + Number(b.quantity || 0), 0);
// // const totalAmount = data.reduce((a, b) => a + Number(b.amount || 0), 0);

// // tableRows.push([
// //   "",
// //   "",
// //   "TOTAL",
// //   "",
// //   totalQty.toLocaleString(undefined, { minimumFractionDigits: 2 }),
// //   "",
// //   `Rs. ${totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
// // ]);


// // autoTable(doc, {
// //   startY: 42,
// //   head: [["#", "Date", "Item", "Vehicle", "Qty", "Rate", "Amount"]],
// //   body: tableRows,
// //   theme: "grid",
// //   styles: {
// //     fontSize: 9,
// //     cellPadding: 2,
// //     textColor: [0, 0, 0],
// //     lineColor: [0, 0, 0],
// //     lineWidth: 0.3,
// //   },
// //   headStyles: {
// //     fontStyle: "bold",
// //     textColor: [0, 0, 0],
// //     fillColor: [255, 255, 255],
// //   },
// //   columnStyles: {
// //     0: { halign: "center", cellWidth: 8 },   // #
// //     1: { halign: "center", cellWidth: 30 },  // Date
// //     2: { halign: "left",   cellWidth: 40 },  // Item
// //     3: { halign: "center", cellWidth: 25 },  // Vehicle
// //     4: { halign: "right",  cellWidth: 20 },  // Qty
// //     5: { halign: "right",  cellWidth: 20 },  // Rate
// //     6: { halign: "right",  cellWidth: 30 },  // Amount
// //   },
// //   didParseCell: (d) => {
// //     if (d.row.raw?.[2] === "TOTAL") {
// //       d.cell.styles.fontStyle = "bold";
// //     }
// //   },
// // });


// // /* ================= AMOUNT IN WORDS ================= */
// // let y = doc.lastAutoTable.finalY + 10;

// // doc.setFont("helvetica", "bold");
// // doc.setFontSize(11);
// // doc.text("Amount in Words:", 14, y);

// // doc.setFont("helvetica", "normal");

// // // full text
// // const amountInWords = `Rupees ${numberToWords(totalAmount)} Only`;

// // // max width for wrapping (A4 safe width)
// // const maxWidth = 180;

// // // auto split into multiple lines
// // const wrappedText = doc.splitTextToSize(amountInWords, maxWidth);

// // // render multiline text
// // doc.text(wrappedText, 14, y + 6);


  
// //   /* ================= OPEN PDF ================= */
// //   const pdfBlob = doc.output("blob");
// //   window.open(URL.createObjectURL(pdfBlob));
// // };
// const generatePDF = (billData, summaryData) => {
//   if (
//     (!billData || billData.length === 0) &&
//     (!summaryData || summaryData.length === 0)
//   ) {
//     message.error("No data to generate PDF");
//     return;
//   }

//   const doc = new jsPDF("p", "mm", "a4");

//   /* =========================================================
//       PAGE 1 -> PARTY BULK BILL
//   ========================================================= */

//   /* ================= HEADER ================= */
//   doc.setFontSize(14);
//   doc.setFont("helvetica", "bold");
//   doc.text("INVOICE", 105, 12, { align: "center" });

//   doc.setFontSize(9);

//   /* -------- CUSTOMER INFO (LEFT) -------- */
//   const leftLabelX = 14;
//   const leftValueX = 60;

//   doc.setFont("helvetica", "bold");
//   doc.text("Customer:", leftLabelX, 22);
//   doc.text("Customer NTN:", leftLabelX, 28);
//   doc.text("Customer Sales Tax No:", leftLabelX, 34);

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(10);
//   doc.text(state.partyName || "", leftValueX, 22);
//   doc.text(state.customerNTN || "", leftValueX, 28);
//   doc.text(state.customerSaleTaxNo || "", leftValueX, 34);

//   /* -------- INVOICE INFO (RIGHT) -------- */
//   const rightLabelX = 140;
//   const rightValueX = 175;

//   doc.setFont("helvetica", "bold");
//   doc.text("Invoice No:", rightLabelX, 28);

//   doc.setFont("helvetica", "normal");
//   doc.text(String(state.invNo || ""), rightValueX, 28, {
//     align: "right",
//   });

//   /* -------- PERIOD -------- */
//   doc.setFont("helvetica", "bold");

//   doc.text(
//     `Bill From ${formatDateLong(
//       state.startingDate
//     )} To ${formatDateLong(state.enteredOn)}`,
//     105,
//     42,
//     { align: "center" }
//   );

//   /* ================= TABLE PAGE 1 ================= */

//   const billRows = billData.map((r, index) => [
//     index + 1,
//     r.itemName,
//     Number(r.quantity).toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     }),
//     Number(r.saleRate).toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     }),
//     Number(r.amount).toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     }),
//   ]);

//   const totalQty1 = billData.reduce(
//     (a, b) => a + Number(b.quantity || 0),
//     0
//   );

//   const totalAmount1 = billData.reduce(
//     (a, b) => a + Number(b.amount || 0),
//     0
//   );

//   billRows.push([
//     "",
//     "TOTAL",
//     totalQty1.toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     }),
//     "",
//     `Rs ${totalAmount1.toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     })}`,
//   ]);

//   autoTable(doc, {
//     startY: 48,
//     head: [["#", "Item", "Qty", "Rate", "Amount"]],
//     body: billRows,
//     theme: "grid",
//     styles: {
//       fontSize: 9,
//       cellPadding: 2,
//       textColor: [0, 0, 0],
//       lineColor: [0, 0, 0],
//       lineWidth: 0.3,
//     },
//     headStyles: {
//       fontStyle: "bold",
//       textColor: [0, 0, 0],
//       fillColor: [255, 255, 255],
//     },
//     columnStyles: {
//       0: { halign: "center", cellWidth: 10 },
//       1: { halign: "left", cellWidth: 85 },
//       2: { halign: "right", cellWidth: 25 },
//       3: { halign: "right", cellWidth: 30 },
//       4: { halign: "right", cellWidth: 35 },
//     },
//     didParseCell: (d) => {
//       if (d.row.raw?.[1] === "TOTAL") {
//         d.cell.styles.fontStyle = "bold";
//       }
//     },
//   });

//   /* ================= AMOUNT IN WORDS ================= */

//   let y = doc.lastAutoTable.finalY + 8;

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(11);

//   doc.text("Amount in Words:", leftLabelX, y);

//   doc.setFont("helvetica", "normal");

//   const amountInWords1 = numberToWords(totalAmount1);

//   const wrappedText1 = doc.splitTextToSize(
//     amountInWords1,
//     130
//   );

//   doc.text(wrappedText1, leftLabelX + 35, y);

//   /* ================= COMPANY INFO ================= */

//   y += 12;

//   doc.setFont("helvetica", "bold");

//   doc.text("Company:", leftLabelX, y);
//   doc.text("NTN:", leftLabelX, y + 6);
//   doc.text("Address:", leftLabelX, y + 12);
//   doc.text("Phone:", leftLabelX, y + 18);
//   doc.text("Fax:", 100, y + 18);
//   doc.text("Email:", leftLabelX, y + 24);

//   doc.setFont("helvetica", "normal");

//   doc.text(state.siteName || "", leftValueX, y);
//   doc.text(state.NTN || "", leftValueX, y + 6);
//   doc.text(state.siteAddress || "", leftValueX, y + 12);
//   doc.text(state.phoneNo || "", leftValueX, y + 18);
//   doc.text(state.Fax || "", 110, y + 18);
//   doc.text(state.email || "", leftValueX, y + 24);

//   /* ================= FOOTER ================= */

//   doc.setFontSize(8);

//   doc.setFont("helvetica", "italic");

//   doc.text(
//     "This is a system generated invoice",
//     105,
//     285,
//     {
//       align: "center",
//     }
//   );

//   /* =========================================================
//       PAGE 2 -> PARTY BULK BILL SUMMARY
//   ========================================================= */

//   doc.addPage();

//   /* ================= HEADER ================= */

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(14);

//   doc.text(state.siteName || "", 105, 15, {
//     align: "center",
//   });

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(10);

//   doc.text(state.siteAddress || "", 105, 21, {
//     align: "center",
//   });

//   /* ================= DATE ================= */

//   doc.setFont("helvetica", "bold");

//   doc.text(
//     `${formatDateLong(
//       state.startingDate
//     )} to ${formatDateLong(state.enteredOn)}`,
//     105,
//     28,
//     {
//       align: "center",
//     }
//   );

//   /* ================= PARTY ================= */

//   doc.text("Customer:", 14, 36);

//   doc.setFont("helvetica", "normal");

//   doc.text(state.partyName || "", 31, 36);

//   /* ================= TABLE PAGE 2 ================= */

//   const summaryRows = summaryData.map((r, index) => [
//     index + 1,
//     formatDateLong(r.enteredOn),
//     r.itemName,
//     r.regNumber || "",
//     Number(r.quantity).toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     }),
//     Number(r.saleRate).toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     }),
//     Number(r.amount).toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     }),
//   ]);

//   const totalQty2 = summaryData.reduce(
//     (a, b) => a + Number(b.quantity || 0),
//     0
//   );

//   const totalAmount2 = summaryData.reduce(
//     (a, b) => a + Number(b.amount || 0),
//     0
//   );

//   summaryRows.push([
//     "",
//     "",
//     "TOTAL",
//     "",
//     totalQty2.toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     }),
//     "",
//     `Rs. ${totalAmount2.toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//     })}`,
//   ]);

//   autoTable(doc, {
//     startY: 42,
//     head: [
//       [
//         "#",
//         "Date",
//         "Item",
//         "Vehicle",
//         "Qty",
//         "Rate",
//         "Amount",
//       ],
//     ],
//     body: summaryRows,
//     theme: "grid",
//     styles: {
//       fontSize: 9,
//       cellPadding: 2,
//       textColor: [0, 0, 0],
//       lineColor: [0, 0, 0],
//       lineWidth: 0.3,
//     },
//     headStyles: {
//       fontStyle: "bold",
//       textColor: [0, 0, 0],
//       fillColor: [255, 255, 255],
//     },
//     columnStyles: {
//       0: { halign: "center", cellWidth: 8 },
//       1: { halign: "center", cellWidth: 30 },
//       2: { halign: "left", cellWidth: 40 },
//       3: { halign: "center", cellWidth: 25 },
//       4: { halign: "right", cellWidth: 20 },
//       5: { halign: "right", cellWidth: 20 },
//       6: { halign: "right", cellWidth: 30 },
//     },
//     didParseCell: (d) => {
//       if (d.row.raw?.[2] === "TOTAL") {
//         d.cell.styles.fontStyle = "bold";
//       }
//     },
//   });

//   /* ================= AMOUNT IN WORDS ================= */

//   let y2 = doc.lastAutoTable.finalY + 10;

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(11);

//   doc.text("Amount in Words:", 14, y2);

//   doc.setFont("helvetica", "normal");

//   const amountInWords2 = `Rupees ${numberToWords(
//     totalAmount2
//   )} Only`;

//   const wrappedText2 = doc.splitTextToSize(
//     amountInWords2,
//     180
//   );

//   doc.text(wrappedText2, 14, y2 + 6);

//   /* ================= OPEN PDF ================= */

//   const pdfBlob = doc.output("blob");

//   window.open(URL.createObjectURL(pdfBlob));
// };

// /* ================= HELPERS ================= */

// // Format date like "10 January 2026"
// function formatDateLong(date) {
//   if (!date) return "";
//   const d = new Date(date);
//   const options = { day: "numeric", month: "long", year: "numeric" };
//   return d.toLocaleDateString("en-US", options);
// }

// // Convert number to words
// const numberToWords = (amount) => {
//   const th = ["", "Thousand", "Million", "Billion", "Trillion"];
//   const dg = ["Zero","One","Two","Three","Four","Five","Six","Seven","Eight","Nine"];
//   const tn = ["Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
//   const tw = ["Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
//   amount = amount.toString().replace(/[\, ]/g,'');
//   if(isNaN(amount)) return "Not a number";
//   let x=amount.indexOf(".");
//   let n=x===-1?amount.length:x;
//   let str=""; let sk=0;
//   for(let i=0;i<n;i++){
//     if((n-i)%3===2){
//       if(amount[i]==="1"){
//         str+=tn[Number(amount[i+1])] + " "; i++; sk=1;
//       } else if(amount[i]!=="0"){
//         str+=tw[Number(amount[i])-2] + " "; sk=1;
//       }
//     } else if(amount[i]!=="0"){
//       str+=dg[Number(amount[i])] + " ";
//       if((n-i)%3===0) str+="Hundred ";
//       sk=1;
//     }
//     if((n-i)%3===1){
//       if(sk) str+=th[(n-i-1)/3] + " "; sk=0;
//     }
//   }
//   if(x!==-1){
//     let y=amount.length; 
//     str+="Point "; 
//     for(let i=x+1;i<y;i++) str+=dg[Number(amount[i])] + " ";
//   }
//   return str.trim() + " Rupees Only";
// };




//   return (
//     <>
//       <div className="flex  bg-black main">
//         <SideBar />
//         <div className="h-full  flex flex-col content-center  w-full">
//           <Header />
//           <div className="flex justify-center mt-10">
//             <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
//               <div className="bg-blue-500 headingBox flex justify-center">
//                 <h1 className=" text-white">Party Bulk Bill + Summary</h1>
//               </div>
//                <div className="flex justify-center w-100">
//                   <div>
//                     <label className="text-white ml-2 mr-2" for="fname">
//                       Account:
//                     </label>
//                     <Select
//                       showSearch
//                       style={{
//                         cursor: "pointer !important",
//                         background: "red !important",
//                       }}
//                       name="partyId"
//                       placeholder="A/C No."
//                       // className=" custom-select ant-select bg-black text-white inpTxt mt-5 p-1 h-9 w-64"
//                       className="ant-select-item-option-active bg-black text-white  mt-5 h-9  w-64"
//                       optionFilterProp="children"
//                       value={state.partyId || "A/C No."}
//                       onChange={(e) => {
//                         console.log("e", e);

//                         const _party = state.parties.find(
//                           (el) => el.partyId === e
//                         );
//                         if (_party) {
//                           setState({
//                             ...state,
//                             partyId: e,
//                             partyName: _party.PartyName,
//                           });
//                         } else {
//                           setState({
//                             ...state,
//                             partyId: e,
//                             partyName: "",
//                           });
//                         }
//                       }}
//                     >
//                       <Option value={0}>None</Option>
//                       {state.parties.map((el) => (
//                         <Option
//                           className="w-auto"
//                           value={el.partyId}
//                         >{`${el.partyId} - ${el.PartyName}`}</Option>
//                       ))}
//                     </Select>
//                   </div>

                 
//                 </div>
//               <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
//                 <div>
//                   <label className="text-white" for="fname">
//                     Starting Date:
//                   </label>
//                   <input
//                     type="date"
//                     name="startingDate"
//                     value={state.startingDate}
//                     onChange={onChangeText}
//                     className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
//                   />
//                   <label className="text-white ml-2" for="fname">
//                     Ending Date:
//                   </label>
//                   <input
//                     type="date"
//                     name="enteredOn"
//                     value={state.enteredOn}
//                     onChange={onChangeText}
//                     className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
//                   />
//                 </div>
               

//                 <div>
//                   <button
//                     className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
//                       loading
//                         ? "opacity-50 cursor-not-allowed"
//                         : "hover:bg-blue-700"
//                     }`}
//                     onClick={editHandler}
//                     disabled={loading}
//                   >
//                     {loading ? "Loading..." : "View"}
//                   </button>
//                   <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
//                     clear
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PartyBulkBillSummary;


import React, { useState, useEffect } from "react";
import { getPartyBulkBillSummary, getPartyBulkBill } from "../../../api/endpoints/allReports.js";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar.js";
import { getAllPartySearch } from "../../../api/endpoints/search.js";
import { Button, Dropdown, Select, Menu } from "antd";
import Header from "../../header/header.jsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence, updateRefrence } from "../../../api/endpoints/refrences";
import { getSingleParty } from "../../../api/endpoints/party.js";
const { Option } = Select;

const PartyBulkBillSummary = () => {
  const { user, access_token } = useSelector(authSelector);
  const [enteredOn, setEnteredOn] = useState("");
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();

  const [state, setState] = useState({
    parties: [],
    partyId: "", //ac no.
    partyName: "", // supplier name
    enteredOn: "",
    reportType: "0",
    startingDate: "",
    customerNTN: "",
    customerSaleTaxNo: "",
    invNo: "",
    STR: "",
    NTN: "",
    siteAddress: "",
    siteName: "",
    phoneNo: "",
    Fax: "",
applyInvNo: false,
    email: "",

  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const [itemsQueue, setItemsQueue] = useState([]);

  function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }
  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.getMonth() + 1; // months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

    const getAllData = async () => {
      const result = await getSiteRefrence(access_token);
      const _parties = await getAllPartySearch(access_token);
      setState({
        ...state,
        parties: _parties,
        STR: result.data.saleTaxNo,
        NTN: result.data.NTNNO,
        phoneNo: result.data.phoneNo,
        invNo: result.data.invoiceNo,
        Fax: result.data.Fax,
        email: result.data.email,
        siteAddress: result.data.siteAddress,
        siteName: result.data.siteName
  
      });
    };

  useEffect(() => {
    getAllData();
    getName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [loading, setLoading] = useState(false);

  const clearState = () => {
    setItemsQueue([]);
  };

const editHandler = async () => {
  if (!state.enteredOn)
    return message.error("Please type Ending date !");
    
  if (!state.startingDate)
    return message.error("Please type Starting date !");
    
  if (!state.partyId)
    return message.error("Please type Party Id !");

  const data = {
    startingDate: state.startingDate,
    enteredOn: state.enteredOn,
    partyId: state.partyId,
  };

  try {
    setLoading(true);

    // BOTH API CALLS
    const [billResult, summaryResult] = await Promise.all([
      getPartyBulkBill(data, access_token),
      getPartyBulkBillSummary(data, access_token),
    ]);

    if (
      !billResult.success &&
      !summaryResult.success
    ) {
      return message.error("No Record Found");
    }

    // DETAIL DATA
    const billPayload = billResult?.data?.map((curr) => ({
      partyId: Number(curr.partyId),
      partyName: curr.partyName,
      itemCode: curr.itemCode,
      itemName: curr.itemName,
      saleRate: Number(curr.saleRate),
      quantity: Number(curr.quantity),
      amount: Number(curr.amount),
      siteId: curr.siteId,
    })) || [];

    // SUMMARY DATA
    const summaryPayload = summaryResult?.data?.map((curr) => ({
      enteredOn: curr.enteredOn,
      partyId: Number(curr.partyId),
      regNumber: curr.regNumber,
      partyName: curr.partyName,
      itemCode: curr.itemCode,
      itemName: curr.itemName,
      saleRate: Number(curr.saleRate),
      quantity: Number(curr.quantity),
      amount: Number(curr.amount),
      siteId: curr.siteId,
    })) || [];

    // SINGLE PDF
    generatePDF(billPayload, summaryPayload);
    // let invUpdateNo = {
    //             invoiceNo:  state.invNo + 1,
    //             siteId: Number(user.siteId)
    //           }
    //           const invUpdate = await updateRefrence(invUpdateNo, access_token);
    //           const result = await getSiteRefrence(access_token);
    //            setState({
    //           ...state,
    //           invNo: result.data.invoiceNo
    //         });
    let invUpdateNo = null;

if (state.applyInvNo) {
  invUpdateNo = {
    invoiceNo: state.invNo + 1,
    siteId: Number(user.siteId),
  };

  await updateRefrence(invUpdateNo, access_token);

  const result = await getSiteRefrence(access_token);

  setState({
    ...state,
    invNo: result.data.invoiceNo,
  });
}

  } catch (err) {
    console.log(err);
    message.error("Something went wrong!");
  } finally {
    setLoading(false);
  }
};
  


// const generatePDF = (data) => {
//   if (!data || data.length === 0) {
//     message.error("No data to generate PDF");
//     return;
//   }

//   const doc = new jsPDF("p", "mm", "a4");

//   /* ================= HEADER (CENTER) ================= */
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(14);
//   doc.text(state.siteName || "", 105, 15, { align: "center" });

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(10);
//   doc.text(state.siteAddress || "", 105, 21, { align: "center" });

//   /* ================= DATE (CENTER) ================= */
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(10);
//   doc.text(
//     `${formatDateLong(state.startingDate)} to ${formatDateLong(state.enteredOn)}`,
//     105,
//     28,
//     { align: "center" }
//   );

//   /* ================= PARTY INFO (LEFT) ================= */
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(10);
//   doc.text("Cutomer:", 14, 36);

//   doc.setFont("helvetica", "normal");
//   doc.text(state.partyName || "", 31, 36);

//   /* ================= TABLE ================= */
// const tableRows = data.map((r, index) => [
//   index + 1,
//   formatDateLong(r.enteredOn),          
//   r.itemName,                           
//   r.regNumber || "",                    
//   r.quantity.toLocaleString(undefined, { minimumFractionDigits: 2 }),
//   r.saleRate.toLocaleString(undefined, { minimumFractionDigits: 2 }),
//   r.amount.toLocaleString(undefined, { minimumFractionDigits: 2 }),
// ]);


// const totalQty = data.reduce((a, b) => a + Number(b.quantity || 0), 0);
// const totalAmount = data.reduce((a, b) => a + Number(b.amount || 0), 0);

// tableRows.push([
//   "",
//   "",
//   "TOTAL",
//   "",
//   totalQty.toLocaleString(undefined, { minimumFractionDigits: 2 }),
//   "",
//   `Rs. ${totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
// ]);


// autoTable(doc, {
//   startY: 42,
//   head: [["#", "Date", "Item", "Vehicle", "Qty", "Rate", "Amount"]],
//   body: tableRows,
//   theme: "grid",
//   styles: {
//     fontSize: 9,
//     cellPadding: 2,
//     textColor: [0, 0, 0],
//     lineColor: [0, 0, 0],
//     lineWidth: 0.3,
//   },
//   headStyles: {
//     fontStyle: "bold",
//     textColor: [0, 0, 0],
//     fillColor: [255, 255, 255],
//   },
//   columnStyles: {
//     0: { halign: "center", cellWidth: 8 },   // #
//     1: { halign: "center", cellWidth: 30 },  // Date
//     2: { halign: "left",   cellWidth: 40 },  // Item
//     3: { halign: "center", cellWidth: 25 },  // Vehicle
//     4: { halign: "right",  cellWidth: 20 },  // Qty
//     5: { halign: "right",  cellWidth: 20 },  // Rate
//     6: { halign: "right",  cellWidth: 30 },  // Amount
//   },
//   didParseCell: (d) => {
//     if (d.row.raw?.[2] === "TOTAL") {
//       d.cell.styles.fontStyle = "bold";
//     }
//   },
// });


// /* ================= AMOUNT IN WORDS ================= */
// let y = doc.lastAutoTable.finalY + 10;

// doc.setFont("helvetica", "bold");
// doc.setFontSize(11);
// doc.text("Amount in Words:", 14, y);

// doc.setFont("helvetica", "normal");

// // full text
// const amountInWords = `Rupees ${numberToWords(totalAmount)} Only`;

// // max width for wrapping (A4 safe width)
// const maxWidth = 180;

// // auto split into multiple lines
// const wrappedText = doc.splitTextToSize(amountInWords, maxWidth);

// // render multiline text
// doc.text(wrappedText, 14, y + 6);


  
//   /* ================= OPEN PDF ================= */
//   const pdfBlob = doc.output("blob");
//   window.open(URL.createObjectURL(pdfBlob));
// };
const generatePDF = (billData, summaryData) => {
  if (
    (!billData || billData.length === 0) &&
    (!summaryData || summaryData.length === 0)
  ) {
    message.error("No data to generate PDF");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");

  /* =========================================================
      PAGE 1 -> PARTY BULK BILL
  ========================================================= */

  /* ================= HEADER ================= */
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("INVOICE", 105, 12, { align: "center" });

  doc.setFontSize(9);

  /* -------- CUSTOMER INFO (LEFT) -------- */
  const leftLabelX = 14;
  const leftValueX = 60;

  doc.setFont("helvetica", "bold");
  doc.text("Customer:", leftLabelX, 22);
  doc.text("Customer NTN:", leftLabelX, 28);
  doc.text("Customer Sales Tax No:", leftLabelX, 34);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(state.partyName || "", leftValueX, 22);
  doc.text(state.customerNTN || "", leftValueX, 28);
  doc.text(state.customerSaleTaxNo || "", leftValueX, 34);

  /* -------- INVOICE INFO (RIGHT) -------- */
  const rightLabelX = 140;
  const rightValueX = 175;

  // doc.setFont("helvetica", "normal");
  // doc.text(String(state.invNo || ""), rightValueX, 28, {
  //   align: "right",
  // });
  if (state.applyInvNo) {
  doc.setFont("helvetica", "bold");
  doc.text("Invoice No:", rightLabelX, 28);

  doc.setFont("helvetica", "normal");
  doc.text(String(state.invNo || ""), rightValueX, 28, {
    align: "right",
  });
}

  /* -------- PERIOD -------- */
  doc.setFont("helvetica", "bold");

  doc.text(
    `Bill From ${formatDateLong(
      state.startingDate
    )} To ${formatDateLong(state.enteredOn)}`,
    105,
    42,
    { align: "center" }
  );

  /* ================= TABLE PAGE 1 ================= */

  const billRows = billData.map((r, index) => [
    index + 1,
    r.itemName,
    Number(r.quantity).toLocaleString(undefined, {
      minimumFractionDigits: 2,
    }),
    Number(r.saleRate).toLocaleString(undefined, {
      minimumFractionDigits: 2,
    }),
    Number(r.amount).toLocaleString(undefined, {
      minimumFractionDigits: 2,
    }),
  ]);

  const totalQty1 = billData.reduce(
    (a, b) => a + Number(b.quantity || 0),
    0
  );

  const totalAmount1 = billData.reduce(
    (a, b) => a + Number(b.amount || 0),
    0
  );

  billRows.push([
    "",
    "TOTAL",
    totalQty1.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    }),
    "",
    `Rs ${totalAmount1.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    })}`,
  ]);

  autoTable(doc, {
    startY: 48,
    head: [["#", "Item", "Qty", "Rate", "Amount"]],
    body: billRows,
    theme: "grid",
    styles: {
      fontSize: 9,
      cellPadding: 2,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0.3,
    },
    headStyles: {
      fontStyle: "bold",
      textColor: [0, 0, 0],
      fillColor: [255, 255, 255],
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 10 },
      1: { halign: "left", cellWidth: 85 },
      2: { halign: "right", cellWidth: 25 },
      3: { halign: "right", cellWidth: 30 },
      4: { halign: "right", cellWidth: 35 },
    },
    didParseCell: (d) => {
      if (d.row.raw?.[1] === "TOTAL") {
        d.cell.styles.fontStyle = "bold";
      }
    },
  });

  /* ================= AMOUNT IN WORDS ================= */

  let y = doc.lastAutoTable.finalY + 8;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);

  doc.text("Amount in Words:", leftLabelX, y);

  doc.setFont("helvetica", "normal");

  const amountInWords1 = numberToWords(totalAmount1);

  const wrappedText1 = doc.splitTextToSize(
    amountInWords1,
    130
  );

  doc.text(wrappedText1, leftLabelX + 35, y);

  /* ================= COMPANY INFO ================= */

  y += 12;

  doc.setFont("helvetica", "bold");

  doc.text("Company:", leftLabelX, y);
  doc.text("NTN:", leftLabelX, y + 6);
  doc.text("Address:", leftLabelX, y + 12);
  doc.text("Phone:", leftLabelX, y + 18);
  doc.text("Fax:", 100, y + 18);
  doc.text("Email:", leftLabelX, y + 24);

  doc.setFont("helvetica", "normal");

  doc.text(state.siteName || "", leftValueX, y);
  doc.text(state.NTN || "", leftValueX, y + 6);
  doc.text(state.siteAddress || "", leftValueX, y + 12);
  doc.text(state.phoneNo || "", leftValueX, y + 18);
  doc.text(state.Fax || "", 110, y + 18);
  doc.text(state.email || "", leftValueX, y + 24);

  /* ================= FOOTER ================= */

  doc.setFontSize(8);

  doc.setFont("helvetica", "italic");

  doc.text(
    "This is a system generated invoice",
    105,
    285,
    {
      align: "center",
    }
  );

  /* =========================================================
      PAGE 2 -> PARTY BULK BILL SUMMARY
  ========================================================= */

  doc.addPage();

  /* ================= HEADER ================= */

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);

  doc.text(state.siteName || "", 105, 15, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text(state.siteAddress || "", 105, 21, {
    align: "center",
  });

  /* ================= DATE ================= */

  doc.setFont("helvetica", "bold");

  doc.text(
    `${formatDateLong(
      state.startingDate
    )} to ${formatDateLong(state.enteredOn)}`,
    105,
    28,
    {
      align: "center",
    }
  );

  /* ================= PARTY ================= */

  doc.text("Customer:", 14, 36);

  doc.setFont("helvetica", "normal");

  doc.text(state.partyName || "", 31, 36);

  /* ================= TABLE PAGE 2 ================= */

  const summaryRows = summaryData.map((r, index) => [
    index + 1,
    formatDateLong(r.enteredOn),
    r.itemName,
    r.regNumber || "",
    Number(r.quantity).toLocaleString(undefined, {
      minimumFractionDigits: 2,
    }),
    Number(r.saleRate).toLocaleString(undefined, {
      minimumFractionDigits: 2,
    }),
    Number(r.amount).toLocaleString(undefined, {
      minimumFractionDigits: 2,
    }),
  ]);

  const totalQty2 = summaryData.reduce(
    (a, b) => a + Number(b.quantity || 0),
    0
  );

  const totalAmount2 = summaryData.reduce(
    (a, b) => a + Number(b.amount || 0),
    0
  );

  summaryRows.push([
    "",
    "",
    "TOTAL",
    "",
    totalQty2.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    }),
    "",
    `Rs. ${totalAmount2.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    })}`,
  ]);

  autoTable(doc, {
    startY: 42,
    head: [
      [
        "#",
        "Date",
        "Item",
        "Vehicle",
        "Qty",
        "Rate",
        "Amount",
      ],
    ],
    body: summaryRows,
    theme: "grid",
    styles: {
      fontSize: 9,
      cellPadding: 2,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0.3,
    },
    headStyles: {
      fontStyle: "bold",
      textColor: [0, 0, 0],
      fillColor: [255, 255, 255],
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 8 },
      1: { halign: "center", cellWidth: 30 },
      2: { halign: "left", cellWidth: 40 },
      3: { halign: "center", cellWidth: 25 },
      4: { halign: "right", cellWidth: 20 },
      5: { halign: "right", cellWidth: 20 },
      6: { halign: "right", cellWidth: 30 },
    },
    didParseCell: (d) => {
      if (d.row.raw?.[2] === "TOTAL") {
        d.cell.styles.fontStyle = "bold";
      }
    },
  });

  /* ================= AMOUNT IN WORDS ================= */

  let y2 = doc.lastAutoTable.finalY + 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);

  doc.text("Amount in Words:", 14, y2);

  doc.setFont("helvetica", "normal");

  const amountInWords2 = `Rupees ${numberToWords(
    totalAmount2
  )} Only`;

  const wrappedText2 = doc.splitTextToSize(
    amountInWords2,
    180
  );

  doc.text(wrappedText2, 14, y2 + 6);

  /* ================= OPEN PDF ================= */

  const pdfBlob = doc.output("blob");

  window.open(URL.createObjectURL(pdfBlob));
};

/* ================= HELPERS ================= */

// Format date like "10 January 2026"
function formatDateLong(date) {
  if (!date) return "";
  const d = new Date(date);
  const options = { day: "numeric", month: "long", year: "numeric" };
  return d.toLocaleDateString("en-US", options);
}

// Convert number to words
const numberToWords = (amount) => {
  const th = ["", "Thousand", "Million", "Billion", "Trillion"];
  const dg = ["Zero","One","Two","Three","Four","Five","Six","Seven","Eight","Nine"];
  const tn = ["Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
  const tw = ["Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
  amount = amount.toString().replace(/[\, ]/g,'');
  if(isNaN(amount)) return "Not a number";
  let x=amount.indexOf(".");
  let n=x===-1?amount.length:x;
  let str=""; let sk=0;
  for(let i=0;i<n;i++){
    if((n-i)%3===2){
      if(amount[i]==="1"){
        str+=tn[Number(amount[i+1])] + " "; i++; sk=1;
      } else if(amount[i]!=="0"){
        str+=tw[Number(amount[i])-2] + " "; sk=1;
      }
    } else if(amount[i]!=="0"){
      str+=dg[Number(amount[i])] + " ";
      if((n-i)%3===0) str+="Hundred ";
      sk=1;
    }
    if((n-i)%3===1){
      if(sk) str+=th[(n-i-1)/3] + " "; sk=0;
    }
  }
  if(x!==-1){
    let y=amount.length; 
    str+="Point "; 
    for(let i=x+1;i<y;i++) str+=dg[Number(amount[i])] + " ";
  }
  return str.trim() + " Rupees Only";
};




  return (
    <>
      <div className="flex  bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <Header />
          <div className="flex justify-center mt-10">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className=" text-white">Party Bulk Bill + Summary</h1>
              </div>
               <div className="flex justify-center w-100">
                  <div>
                    <label className="text-white ml-2 mr-2" for="fname">
                      Account:
                    </label>
                    <Select
                      showSearch
                      style={{
                        cursor: "pointer !important",
                        background: "red !important",
                      }}
                      name="partyId"
                      placeholder="A/C No."
                      // className=" custom-select ant-select bg-black text-white inpTxt mt-5 p-1 h-9 w-64"
                      className="ant-select-item-option-active bg-black text-white  mt-5 h-9  w-64"
                      optionFilterProp="children"
                      value={state.partyId || "A/C No."}
                      onChange={(e) => {
                        console.log("e", e);

                        const _party = state.parties.find(
                          (el) => el.partyId === e
                        );
                        if (_party) {
                          setState({
                            ...state,
                            partyId: e,
                            partyName: _party.PartyName,
                          });
                        } else {
                          setState({
                            ...state,
                            partyId: e,
                            partyName: "",
                          });
                        }
                      }}
                    >
                      <Option value={0}>None</Option>
                      {state.parties.map((el) => (
                        <Option
                          className="w-auto"
                          value={el.partyId}
                        >{`${el.partyId} - ${el.PartyName}`}</Option>
                      ))}
                    </Select>
                  </div>

                 
                </div>
              <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
                <div>
                  <label className="text-white" for="fname">
                    Starting Date:
                  </label>
                  <input
                    type="date"
                    name="startingDate"
                    value={state.startingDate}
                    onChange={onChangeText}
                    className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
                  />
                  <label className="text-white ml-2" for="fname">
                    Ending Date:
                  </label>
                  <input
                    type="date"
                    name="enteredOn"
                    value={state.enteredOn}
                    onChange={onChangeText}
                    className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
                  />
                </div>
               <div className="flex items-center mt-4">
  <input
    type="checkbox"
    checked={state.applyInvNo}
    onChange={(e) =>
      setState({
        ...state,
        applyInvNo: e.target.checked,
      })
    }
    className="mr-2"
  />

  <label className="text-white">
    Apply Invoice No
  </label>
</div>

                <div>
                  <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                  <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                    clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartyBulkBillSummary;
